import React from 'react';
import styled from 'styled-components';
import sx from '../../sx';
import { Box, Stack } from '../..';
const GettingStartedPageGridContainer = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, null, children));
};
const Wrapper = styled(Box).withConfig({
  displayName: "GettingStartedPageGridContainer__Wrapper",
  componentId: "sc-nngvlr-0"
})(["border:1px solid;border-color:red;display:grid;grid-template-columns:repeat(12,minmax(0,1fr));"]);
const Header = styled(Box).withConfig({
  displayName: "GettingStartedPageGridContainer__Header",
  componentId: "sc-nngvlr-1"
})(["grid-area:microheader;", ""], sx);
const ContentStack = styled(Stack).withConfig({
  displayName: "GettingStartedPageGridContainer__ContentStack",
  componentId: "sc-nngvlr-2"
})(["grid-area:content-stack;", ""], sx);
const Footer = styled(Box).withConfig({
  displayName: "GettingStartedPageGridContainer__Footer",
  componentId: "sc-nngvlr-3"
})(["grid-area:footer;", ""], sx);
export default GettingStartedPageGridContainer;